<template>
	<div class="xl-sas" style="padding: 10px">
	    <left-menu :width="'220px'"></left-menu>
	    <div class="contentBox" :style="{height: clientHeight}">
	        <keep-alive>
                <router-view></router-view>
            </keep-alive>
	    </div>
	</div>
</template>
<script>
    import leftMenu from '@/components/leftMenu/left-menu'
    export default {
        components:{leftMenu},
        name: "system-setup",
        data(){
          return{
              clientHeight:'',
          }
        },
        created() {
            this.clientHeight = (document.body.clientHeight - 120) +'px';
        }
    }
</script>

<style lang="less" scoped>
    .xl-sas{
		display: flex;
        .contentBox{
            flex:1;
			height: 100%;
        }
    }

</style>